<template>
    <div>
        <slot />
        <div>
            <el-checkbox-group v-model="settings.notification_channels">
                <el-checkbox label="mail">Email</el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="mt-20">
            <g-button :disabled="contactStore.loading" shape="round" theme="live" @click="updateSettings">
                <g-typography font-weight="semibold">Update</g-typography>
            </g-button>
        </div>
    </div>
</template>

<script>
    import { useContactStore } from '../../../../../stores';
    import { message } from '@grininc/grin-ui';
    import { reactive } from 'vue-demi';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'NotificationSettings',

        setup() {
            const contactStore = useContactStore();

            const settings = reactive({ notification_channels: contactStore.data.notification_channels || ['mail'] });

            const updateSettings = async () => {
                await contactStore.updateNotificationChannels(settings);

                if (!contactStore.error) {
                    message.success('Your profile has been updated.');
                } else {
                    message.error(contactStore.error);
                }
            };

            return {
                contactStore,
                settings,
                updateSettings
            };
        }
    };
</script>
